module.exports = __webpack_public_path__ + "files/SPIADI2021 - Rapport RÉA explAUR.1a0c8dc9c6704c579fdfcdc66a8a96a8.pdf";